// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2N8mL","list":"BalanceDue_list__2YMTw","listRow":"BalanceDue_listRow__mdbt8","total":"BalanceDue_total__1Tdoi"};